<section class="rsr" aria-labelledby="rsrTitle">
  <div class="rsr__summary">
    <div class="kpi" [class.kpi--loading]="isLoading" aria-label="Total Registered">
      @if(isLoading){
      <app-loading-skeleton [count]="1" width="100%" height="100%" borderRadius="8px"></app-loading-skeleton>
      }@else{
      <div class="kpi__head">
        <div class="kpi__icon kpi__icon--users" aria-hidden="true"></div>
        <div class="kpi__title">Total Registered</div>
      </div>
      <div class="kpi__value">{{ totalRegistered | number }}</div>
      <div class="kpi__sub">out of {{ totalCapacity | number }}</div>
      }
    </div>

    <div class="kpi" [class.kpi--loading]="isLoading" aria-label="Total Locations">
      @if(isLoading){
      <app-loading-skeleton [count]="1" width="100%" height="100%" borderRadius="8px"></app-loading-skeleton>
      }@else{
      <div class="kpi__head">
        <div class="kpi__icon kpi__icon--pin" aria-hidden="true"></div>
        <div class="kpi__title">Total Locations</div>
      </div>
      <div class="kpi__value">{{ totalLocations }}</div>
      <div class="kpi__sub">Nationwide</div>
      }
    </div>

    <div class="wide-progress" [class.kpi--loading]="isLoading"
      [attr.aria-label]="'Nationwide progress ' + totalPercent + '%'">
      @if(isLoading){
      <app-loading-skeleton [count]="1" width="100%" height="100%" borderRadius="8px"></app-loading-skeleton>
      }@else{
      <div class="wide-progress__header">
        <div>
          <div class="wide-progress__title">Nationwide Progress</div>
          <div class="wide-progress__sub">Overall registration completion</div>
        </div>
        <div class="wide-progress__pct">
          {{ totalPercent }}%
          <span>Complete</span>
        </div>
      </div>

      <div class="wide-progress__track">
        <div class="wide-progress__bar" [style.width.%]="totalPercent"></div>
      </div>
      }
    </div>
  </div>

  @if(isLoading){
  <div class="registration-status-row registration-status-row--loading" aria-hidden="true">
    <div class="status-skeleton title">
      <app-loading-skeleton [count]="1" height="20px" width="180px" borderRadius="6px"></app-loading-skeleton>
    </div>
    <div class="status-skeleton item">
      <app-loading-skeleton [count]="1" height="20px" width="170px" borderRadius="999px"></app-loading-skeleton>
    </div>
    <div class="status-skeleton item">
      <app-loading-skeleton [count]="1" height="20px" width="170px" borderRadius="999px"></app-loading-skeleton>
    </div>
    <div class="status-skeleton item">
      <app-loading-skeleton [count]="1" height="20px" width="170px" borderRadius="999px"></app-loading-skeleton>
    </div>
    <div class="status-skeleton item">
      <app-loading-skeleton [count]="1" height="20px" width="150px" borderRadius="999px"></app-loading-skeleton>
    </div>
  </div>
  }@else{
  <div class="registration-status-row" aria-label="Registration status scale">
    <span class="status-title">Registration Status:</span>
    <span class="status-item">
      <span class="status-dot nearly-full" aria-hidden="true"></span>
      90%+ (Nearly Full)
    </span>
    <span class="status-item">
      <span class="status-dot on-track" aria-hidden="true"></span>
      70-89% (On Track)
    </span>
    <span class="status-item">
      <span class="status-dot moderate" aria-hidden="true"></span>
      50-69% (Moderate)
    </span>
    <span class="status-item">
      <span class="status-dot low" aria-hidden="true"></span>
      &lt;50% (Low)
    </span>
  </div>
  }

  <div class="rsr__grid" role="list">
    @if(isLoading){
    @for (idx of skeletonCards; track idx) {
    <article class="rsr__card rsr__card--loading" role="listitem" aria-label="Loading event registration card">
      <app-loading-skeleton [count]="1" width="100%" height="100%" minHeight="180px"
        borderRadius="8px"></app-loading-skeleton>
    </article>
    }
    }@else{
    @for (e of events; track e) {
    <article class="rsr__card" role="listitem" [class.is-full]="isFull(e)" [attr.aria-label]="e.city + ' – ' + e.venue">
      <div class="card__head">
        <div class="card__head-left">
          <h3 class="card__city">
            {{ e?.city }}
          </h3>
          <div class="card__venue">{{ e?.venue }}</div>
        </div>

        <div class="card__head-right">
          <div class="card__attended">
            {{ e?.registeredCount | number }}
          </div>
          <div class="card__of">of {{ e?.capacity | number }}</div>
        </div>
      </div>
      <div class="card__date" aria-label="Venue registration start date">
        <span class="card__date-label">Starts On:</span>
        <span class="card__date-value">{{ e?.venue_start_date || 'N/A' }}</span>
      </div>

      <div class="card__progress">
        <div class="card__track">
          <div class="card__bar" [ngClass]="tierClassByPercent(percent(e))" [style.width.%]="percent(e)">
            <span class="card__pct-inline">{{ e?.percentageFilled }}%</span>
          </div>
        </div>

        <div class="card__remaining">
          {{ spotsRemaining(e) }} spots remaining
        </div>
      </div>
    </article>
    }
    }
  </div>
</section>